import {
  AppsIcon, ArrowUpRightIcon, BoxIcon, ChevronUpIcon, ClapIcon, ExpandIcon, FileIcon, ImageIcon, SearchIcon,
  SparkleIcon, WandIcon, WaveIcon, XIcon,
} from '../ProductFrameIcons'

const CATEGORIES = [
  { Icon: AppsIcon, n: 60 },
  { Icon: ImageIcon, n: 41 },
  { Icon: ClapIcon, n: 8 },
  { Icon: WaveIcon, n: 5 },
  { Icon: BoxIcon, n: 3 },
  { Icon: FileIcon, n: 3 },
] as const

const APPS = [
  { Icon: SparkleIcon, name: 'Generate image', body: 'Create an image from a written prompt.' },
  { Icon: WandIcon, name: 'Edit image', body: 'Change an image by describing the edit.' },
  { Icon: ArrowUpRightIcon, name: 'Upscale', body: 'Enlarge an image 2× or 4× and keep it sharp.' },
] as const

/** The Apps inspector: every tool opens from here (about 60 of them). */
export function AppsPanel() {
  return (
    <div className="absolute top-3 right-3 bottom-3 z-10 flex w-[250px] flex-col overflow-hidden rounded-xl border border-line bg-card shadow-[0_2px_8px_rgba(0,0,0,0.05)]">
      <div className="flex items-center gap-1 px-2.5 pt-2.5 text-faint">
        <span className="rounded-md bg-panel px-2 py-1 text-[11px] text-bone">Apps</span>
        <ExpandIcon width={11} height={11} className="ml-auto" />
        <XIcon width={11} height={11} className="ml-2" />
        <ChevronUpIcon width={11} height={11} className="ml-2" />
      </div>
      <div className="px-3.5 pt-4">
        <span className="text-[10px] text-muted">Create &amp; edit</span>
        <p className="mt-1 text-[17px] leading-tight tracking-[-0.01em]">Create and refine.</p>
        <p className="mt-1.5 text-[10.5px] leading-snug text-muted">
          Open an app to create or refine. Every result stays in this session.
        </p>
        <span className="mt-3 flex h-7 items-center gap-2 rounded-md border border-line px-2 text-[10.5px] text-faint">
          <SearchIcon width={11} height={11} />
          Find an app…
        </span>
        <span className="mt-2.5 flex flex-wrap gap-1">
          {CATEGORIES.map(({ Icon, n }, i) => (
            <span
              key={i}
              className={`flex h-6 items-center gap-1 rounded-md border px-1.5 text-[10px] ${i === 0 ? 'border-bone/40 text-bone' : 'border-line text-muted'}`}
            >
              <Icon width={10} height={10} />
              <span className="num">{n}</span>
            </span>
          ))}
        </span>
      </div>
      <div className="mt-3 flex flex-col gap-1.5 px-3.5">
        {APPS.map(({ Icon, name, body }) => (
          <div key={name} className="flex gap-2.5 rounded-lg border border-line p-2.5">
            <span className="flex size-6 flex-none items-center justify-center rounded-md bg-panel text-bone">
              <Icon width={12} height={12} />
            </span>
            <span className="flex flex-col gap-0.5">
              <span className="text-[11px] text-bone">{name}</span>
              <span className="text-[9.5px] leading-snug text-muted">{body}</span>
              <span className="mt-1 w-fit rounded bg-panel px-1.5 py-0.5 text-[9px] text-muted">Free or cloud</span>
            </span>
          </div>
        ))}
      </div>
    </div>
  )
}
